export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_02.d30e52f3.jpg";